import { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { getPersons } from '../../services/treeService'
import useNotifications from '../../hooks/useNotifications'

export default function useTreePersons(treeId) {
  const { t } = useTranslation()
  const { error } = useNotifications()
  const [persons, setPersons] = useState()
  const [from, setFrom] = useState()
  const [nameFilter, setNameFilter] = useState()
  const [sort, setSort] = useState()
  const [lastPage, setLastPage] = useState()
  // 200 is max that the endpoint allows
  const PAGE_SIZE = 200

  useEffect(() => {
    getPersons(treeId, true, 0, nameFilter, sort, PAGE_SIZE)
      .then((personsResponse) => {
        setPersons(personsResponse.data)
        setFrom(personsResponse.data.persons?.length)
        setLastPage(personsResponse.data.nextPageToken === undefined)
      })
      .catch((err) => {
        setLastPage(true)
        error(`${t('tree.error.persons', 'Error getting persons for tree')} ${treeId}: ${err.message || ''}`, err)
      })
  }, [error, nameFilter, sort, t, treeId])

  const fetchMorePersons = () =>
    new Promise((resolve) => {
      if (lastPage === false) {
        getPersons(treeId, true, from, nameFilter, sort, PAGE_SIZE)
          .then((personsResponse) => {
            setPersons(handlePersonsUpdate(personsResponse))
          })
          .catch((err) => {
            setLastPage(true)
            error(`${t('tree.error.persons', 'Error getting persons for tree')} ${treeId}: ${err.message || ''}`, err)
          })
      }
      resolve(!lastPage)
    })

  const personsState = { persons, nameFilter }
  const personsActions = { setFrom, setNameFilter, setSort, fetchMorePersons }

  return { personsState, personsActions }

  function handlePersonsUpdate(personsResponse) {
    return (prevState) => {
      setFrom(personsResponse.data.nextPageToken)
      setLastPage(personsResponse.data.nextPageToken === undefined)
      return {
        ...prevState,
        persons: [...(prevState?.persons || []), ...personsResponse.data.persons],
      }
    }
  }
}
